var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        width: "830px",
        top: "8vh",
        "append-to-body": "",
        "custom-class": "goods-global-search-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        opened: _vm.focusKeyword,
        close: _vm.invalidateSearch,
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "search-title",
          attrs: { slot: "title" },
          slot: "title",
        },
        [
          _c("span", { staticClass: "search-title-icon" }, [_vm._v("🔍")]),
          _c("span", [_vm._v("全局商品搜索")]),
          _c("span", { staticClass: "search-scope-badge" }, [
            _vm._v("跨 5 类课程类型"),
          ]),
        ]
      ),
      _c(
        "div",
        { staticClass: "search-bar" },
        [
          _c("GoodsKeywordSearch", {
            ref: "keywordSearch",
            staticClass: "global-search-keyword",
            attrs: { "dropdown-class": "goods-global-search-options" },
            on: { search: _vm.submitSearch },
            model: {
              value: _vm.search,
              callback: function ($$v) {
                _vm.search = $$v
              },
              expression: "search",
            },
          }),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small", loading: _vm.loading },
              on: { click: _vm.submitSearch },
            },
            [_vm._v("搜索")]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "search-results",
          attrs: { "aria-live": "polite" },
        },
        [
          _vm.error
            ? _c(
                "div",
                { staticClass: "empty-state" },
                [
                  _c("p", [_vm._v("搜索失败，请重试")]),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "small" },
                      on: { click: _vm.fetchResults },
                    },
                    [_vm._v("重新搜索")]
                  ),
                ],
                1
              )
            : !_vm.submitted
            ? _c("div", { staticClass: "empty-state" }, [
                _c(
                  "span",
                  {
                    staticClass: "empty-state-icon",
                    attrs: { "aria-hidden": "true" },
                  },
                  [_vm._v("📚")]
                ),
                _c("p", [
                  _vm._v(
                    "本页面支持根据筛选条件搜索专栏、大专栏、线下课、训练营、套餐课"
                  ),
                ]),
              ])
            : !_vm.loading && !_vm.records.length
            ? _c("div", { staticClass: "empty-state" }, [
                _vm._v("未找到匹配商品，请调整关键词"),
              ])
            : [
                _c("p", { staticClass: "result-count" }, [
                  _vm._v("共找到 " + _vm._s(_vm.total) + " 个商品"),
                ]),
                _vm._l(_vm.records, function (row) {
                  return _c(
                    "div",
                    {
                      key: row.goodsId,
                      staticClass: "result-item",
                      on: {
                        click: function ($event) {
                          return _vm.openDetails(row, $event)
                        },
                      },
                    },
                    [
                      _c(
                        "el-image",
                        {
                          staticClass: "goods-cover",
                          attrs: {
                            src:
                              row.coverVerticalUrl ||
                              row.coverUrl ||
                              row.patchUrl,
                            fit: "cover",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "cover-placeholder",
                              attrs: { slot: "error" },
                              slot: "error",
                            },
                            [_c("i", { staticClass: "el-icon-reading" })]
                          ),
                        ]
                      ),
                      _c("div", { staticClass: "goods-info" }, [
                        _vm.canView(row)
                          ? _c(
                              "a",
                              {
                                staticClass: "goods-name",
                                attrs: {
                                  href: _vm.goodsLink(row),
                                  target: "_blank",
                                  rel: "noopener",
                                },
                              },
                              [_vm._v(_vm._s(row.contentName))]
                            )
                          : _c("span", { staticClass: "goods-name" }, [
                              _vm._v(_vm._s(row.contentName)),
                            ]),
                        _c(
                          "div",
                          { staticClass: "goods-meta" },
                          [
                            _c("el-tag", { attrs: { size: "mini" } }, [
                              _vm._v(_vm._s(_vm.typeLabel(row))),
                            ]),
                            _c("span", [_vm._v("ID：" + _vm._s(row.goodsId))]),
                          ],
                          1
                        ),
                        _c("div", { staticClass: "goods-meta" }, [
                          _c("span", { staticClass: "goods-price" }, [
                            _vm._v(_vm._s(_vm.priceLabel(row))),
                          ]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.shelfLabels[row.shelveFlag] || "未知状态"
                              )
                            ),
                          ]),
                        ]),
                        row.uniqueCode
                          ? _c("div", { staticClass: "unique-code" }, [
                              _vm._v("唯一编码：" + _vm._s(row.uniqueCode)),
                            ])
                          : _vm._e(),
                      ]),
                      _c("div", { staticClass: "goods-actions" }, [
                        _vm.canView(row)
                          ? _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.goodsLink(row),
                                  target: "_blank",
                                  rel: "noopener",
                                },
                              },
                              [_vm._v("详情")]
                            )
                          : _vm._e(),
                        _vm.canEdit(row)
                          ? _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.goodsLink(row, true),
                                  target: "_blank",
                                  rel: "noopener",
                                },
                              },
                              [_vm._v("编辑")]
                            )
                          : _vm._e(),
                      ]),
                    ],
                    1
                  )
                }),
              ],
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "search-footer" },
        [
          _c("span", [_c("kbd", [_vm._v("Enter")]), _vm._v(" 搜索")]),
          _vm.submitted && !_vm.error && _vm.total > _vm.pageSize
            ? _c("el-pagination", {
                attrs: {
                  "current-page": _vm.current,
                  "page-size": _vm.pageSize,
                  total: _vm.total,
                  small: "",
                  layout: "prev, pager, next",
                },
                on: { "current-change": _vm.changePage },
              })
            : _vm._e(),
          _c("span", { staticClass: "close-hint" }, [
            _c("kbd", [_vm._v("Esc")]),
            _vm._v(" 关闭"),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }